var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMessage),expression:"showMessage"}],staticClass:"wrapper",class:_vm.msgClass},[_c('div',{staticClass:"message-title"},[_vm._v(_vm._s(_vm.systemMsg)),_c('ui-close',{staticClass:"flash-close",on:{"close":_vm.clearMessage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }